import { useState } from 'react';
import TablePolicies from "./TablePolicies/TablePolicies";
import MainDetails from './MainDetalis/MainDetalis';
import LoadingMainCard from '../LoadingPages/LoadingMainCard';
import SkeletonTablePolicies from '../LoadingPages/SkeletonTablePolicies';
import Pagination from './Pagination';
import SearchBar from './SearchBar';
import { useQuery } from '@tanstack/react-query';
import { fetchPolicies } from './PoliciesApi';

export default function Policies() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);

  const { data, isLoading, error } = useQuery({
    queryKey: ['getPolicies'],
    queryFn: fetchPolicies,
    staleTime: 29 * 60 * 1000, // 30 minutes
  });

  if (isLoading) {
    return (
      <>
        <LoadingMainCard cards={4} />
        <SkeletonTablePolicies rows={5} />
      </>
    );
  }

  if (error) {
    return <p className="ms-2 text-danger">Error loading policies: {error.message}</p>;
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value) {
      const results = data.filter(item =>
        item.Name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(results);
    } else {
      setFilteredData([]);
    }
  };

  // Determine which data to display
  const displayData = searchTerm ? filteredData : paginatedData;

  return (
    <div className="mt-3">
      <div className="row align-items-center">
        <div className="col-md-4">
          <h1 className="title">Compliance Portal</h1>
        </div>
        {data?.length > 0 && (
          <SearchBar
            searchTerm={searchTerm}
            handleInputChange={handleInputChange}
            filteredData={filteredData}
          />
        )}
      </div>

      {data?.length === 0 ? (
        <p className="ms-2">No policies documents</p>
      ) : (
        <>
          <MainDetails data={data} />
          <TablePolicies data={displayData} allPolices={data} />
          <div className='d-flex justify-content-center mt-4'>
            {data?.length > 0 && !searchTerm && (
              <Pagination polices={data} setPaginatedData={setPaginatedData} />
            )}
          </div>
        </>
      )}
    </div>
  );
}